import {authStatus} from "./Status";
import axios from "../helper/axios";



export const  ProfileAction=(data)=>{
	return async (dispatch)=>{
		dispatch({type:authStatus.PROFILE_GET_REQUEST}); 
	 // alert(data)
		const res = await axios.post(`/getupdateprofile`,data);
		if(res.status===200){
           const data = res.data;  
			dispatch({
				type:authStatus.PROFILE_GET_SUCCESS,
				payload:{
					data
				}
			})

		}else{
		if(res.status===201){
				dispatch({
				type:authStatus.PROFILE_GET_FAILURE,
				payload:{
					data:data
				}
			})
		}
	    }
	}
}